/* global document */
import { gsap } from 'gsap';
import { createSnowEffect } from 'Renderer/utils/effects/snow';
import { createRainEffect } from 'Renderer/utils/effects/rain';
import { createMistEffect } from 'Renderer/utils/effects/mist';

const createEffectLayer = (id) => {
  try {
    const effectLayer = document.getElementById(id).childNodes[0];
    const effectType = effectLayer.getAttribute('data-effect');
    const settings = {};
    settings.size = parseInt(effectLayer.getAttribute('data-size'), 10) || 10;
    settings.speed = parseInt(effectLayer.getAttribute('data-speed'), 10) || 10;
    settings.intensity = parseInt(effectLayer.getAttribute('data-intensity'), 10) || 50;
    if (effectType === 'snow') createSnowEffect(effectLayer, settings);
    if (effectType === 'rain') createRainEffect(effectLayer, settings);
    if (effectType === 'mist') createMistEffect(effectLayer, settings);
  } catch (e) {
    console.log(e);
  }
};

export default createEffectLayer;



// WEBPACK FOOTER //
// ./app/javascript/renderer/utils/effectLayerScript.js